import React from 'react';
import styles from "./Support.module.css";
import { useTranslation } from "react-i18next";

function Support(props) {
  const { t } = useTranslation("common");
  // Close the modal
  const handleClose =(event,reason)=>{
    event.stopPropagation();
    // set close state as false , to close the dialog
    props.setIsModalOpen(false);
  }

  return (
    <>
    <div className='d-flex flex-row'>
   
    
    <div className='d-flex flex-column justify-content-start align-items-start'>
    
        <div>
            <h6 className={styles.supportTitle}> {t("support.tollFreeNumber")} </h6>
            <div className='d-flex flex-row justify-content-center align-items-start text-white'>
                <span className='me-2 tollfree'></span>
                <span>
                <a alt='' href={`tel:${t("support.hyperLinktollNumber")}`} className={styles.supporttxt}> {t("support.tollNumber")} </a>
                  <p className={styles.supportsubtxt}> {t("support.tollFreeTiming")}</p>
                </span>
             </div>
        </div>

        <div>
            <h6 className={styles.supportTitle}>{t("support.emailId")}</h6>
            <div className='d-flex flex-row justify-content-center align-items-start text-white'>
            <span  className='me-2 margin-top emailID'></span>
            <span>
            <a alt='' href={`mailto:${t("support.supportEmail")}`} className={styles.supportLinks}>{t("support.supportEmail")}</a>
             
            </span>
            </div>
            
        </div>
    </div>
    <span className="round_close supportCloseIcon" onClick={(event) => handleClose(event,'click')}></span> 
    </div>

    </>
  )
}

export default Support;
